import React, { memo } from 'react';

const RowItemViewContract = (props) => {
  return (
    <button className="btn btn-default btn-icon btn-primary m-r-2" onClick={props.onClick}>
      <i className="fa fa-file"></i>
    </button>
  );
};

export default memo(RowItemViewContract);
